<template>
  <div>
    <div class="card configMap ">
      <div class="card-header"><p class="m-0">Tipo de evento</p></div>
      <div class="card-body">
        <div class="row">
          <p class="col-9">Mosaicos fotográficos</p>
          <div class="col-3 custom-control custom-switch">
            <input type="checkbox" class="custom-control-input" id="mosaicos" @change="showMosaicos"  v-model="switchMosaicos">
            <label class="custom-control-label" for="mosaicos"></label>
          </div>
        </div>
        <div class="row">
          <p class="col-9">Sonar Lecho Marino</p>
          <div class="col-3 custom-control custom-switch">
            <input type="checkbox" class="custom-control-input" id="sonar" v-model="switchSonar">
            <label class="custom-control-label" for="sonar"></label>
          </div>
        </div>
        <div class="row">
          <p class="col-9">Relieves subbmarinos</p>
          <div class="col-3 custom-control custom-switch">
            <input type="checkbox" class="custom-control-input" id="relieves" v-model="switchRelieves">
            <label class="custom-control-label" for="relieves"></label>
          </div>
        </div>
      </div> 
    </div>
  </div>
</template>

<script>
export default {
  name: "configMap",
  data() {
    return {
      switchMosaicos: false,
      switchSonar: false,
      switchRelieves: false,
    }
  },
   methods: {
     showMosaicos () {
       console.log(this.switchMosaicos)
     }
   }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/configMap.vue